"use strict";

var _require = require('../../products/components'),
    Wrapper = _require.Wrapper,
    MediumWrapper = _require.MediumWrapper,
    ThickWrapper = _require.ThickWrapper;

function isWrapper(component) {
  var wrapper = false;
  [Wrapper, MediumWrapper, ThickWrapper].forEach(function (Embellishment) {
    if (Object.prototype.isPrototypeOf.call(Embellishment.prototype, component)) {
      wrapper = true;
    }
  });
  return wrapper;
}

module.exports = isWrapper;